import React from "react";
import "../Styles/Footer.scss";
import Logo from "../Image/logo.png";

const Footer = () => {
  return (
    <div>
      <footer className="footer">
        <div className="footer-container">
          {/* LOGO & DESCRIPTION */}
          <div className="footer-about">
            <img src={Logo} />
            <h2>KURTI HOTEL</h2>
            <div className="stars">★★★★</div>
            <p>
              Experience luxury and comfort in the heart of the city. Thoughtful
              stays, beautiful moments.
            </p>
          </div>

          {/* NAVIGATION LINKS */}
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/rooms">Rooms</a>
              </li>
              <li>
                <a href="/about">About</a>
              </li>
                            <li>
                <a href="/gallery">Gallery</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>

          {/* CONTACT INFO */}
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <p>Address: Bulevardi i Pishave, Durrës 1000, Albania</p>
            <p>Email: hotelkurti@gmail.com</p>
            <p>Phone: +355 67 673 7777</p>
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Kurti Hotel. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
